import type { MagentoFlavorAttribute } from "@jti/magento-types";

export type SingleFlavorSelectorItem = {
  sku: string;
  name?: string | null;
  description?: string;
  image: {
    url?: string;
  };
  attributes?: MagentoFlavorAttribute[];
  flavorFamily?: string[];
};

export type FlavorFamilyFilter = {
  name: string;
  count: number;
};
